export const FOLLOWING_QUERY_KEY = 'following';
export const FOLLOWERS_QUERY_KEY = 'followers';
export const FOLLOWING_ITEMS_PER_PAGE = 16;

export const FOLLOWING_TABS = [
  { label: 'Following', href: '', showTabCount: true },
  { label: 'Followers', href: '/followers', showTabCount: true },
];
